/* eslint-disable no-useless-escape */
/* eslint-disable no-lone-blocks */
/* eslint-disable max-len */
export const ValidateEmail = (email) => {
    {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    }
};
